import { DeleteOutlined } from "@ant-design/icons";
import { Button } from "antd";
import * as React from "react";
import { columnDisplayId } from "src/business/sysData/sysColumns";
import { getWorkflowStepDisplayName } from "src/business/workflow/getWorkflowStepDisplayName";
import { isSystemStep } from "src/business/workflow/workflowSteps";
import { ZWorkflowStep } from "src/business/workflow/ZWorkflowStep";
import {
  makeMdmActionColumn,
  RenderButtonAction,
} from "src/components/MdmTable";
import { RtColumn } from "src/components/ReactiveTable/RtColumn";

import { PrevStepsCell } from "./PrevStepsCell";
import { stepTypeMap } from "./workflowStepOptions";

type CreateWorkflowStepsColumnsParams = {
  steps: ZWorkflowStep[];
  onEdit: (step: ZWorkflowStep) => void;
  onDelete: (step: ZWorkflowStep) => void;
};

export const createWorkflowStepsColumns = ({
  steps,
  onEdit,
  onDelete,
}: CreateWorkflowStepsColumnsParams): RtColumn<ZWorkflowStep>[] => [
  columnDisplayId,
  {
    key: "name",
    title: "Системное название",
    width: "15%",
    render: (step) => (
      <Button type="link" onClick={() => onEdit(step)} style={{ padding: 0 }}>
        {step.name}
      </Button>
    ),
  },
  {
    key: "displayName",
    title: "Отображаемое название",
    width: "15%",
    render: (step) => getWorkflowStepDisplayName(step),
  },
  {
    key: "description",
    title: "Описание",
    render: ({ description }) => description,
  },
  {
    key: "prevSteps",
    title: "Предшественник",
    width: 200,
    render: (step) => <PrevStepsCell curStep={step} allSteps={steps} />,
  },
  {
    key: "type",
    title: "Тип шага",
    width: "15%",
    render: (step) => (step.type ? stepTypeMap.get(step.type) : null),
  },
  makeMdmActionColumn<ZWorkflowStep>({
    key: "delete",
    // Системные шаги нельзя удалить
    render: (step) =>
      isSystemStep(step) ? null : (
        <RenderButtonAction
          icon={<DeleteOutlined />}
          title={`Удалить ${getWorkflowStepDisplayName(step)}`}
          onClick={() => onDelete(step)}
        />
      ),
  }),
];
